/**
 * What an approval decision is about.
 *
 * Documents only. Agreeing to a reconciliation matching proposed is not an approval — it is a
 * judgement about findings, and it stays a matching operation.
 */
export const ApprovalType = {
  INVOICE_APPROVAL: 'INVOICE_APPROVAL',
  PURCHASE_ORDER_APPROVAL: 'PURCHASE_ORDER_APPROVAL',
  REQUISITION_APPROVAL: 'REQUISITION_APPROVAL'
} as const;

export type ApprovalType = (typeof ApprovalType)[keyof typeof ApprovalType];
